<template>
  <div
    id="banner-header-container"
    class="banner-header-container"
    :class="[isHideBanner ? 'd-none' : 'd-block']"
  >
    <slot name="content" />
  </div>
</template>

<script>

import { nextTick } from '@vue/composition-api'

export default {
  props: {
    bannerInfo: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  data() {
    return {
      isHideBanner: false,
    }
  },

  watch: {
    bannerInfo: {
      async handler(val) {
        if (val) {
          await nextTick()
          let screenType = 'desktop'
          const div = document.getElementById('banner-header-container')
          if (window.matchMedia('(max-width: 767px)').matches) {
            screenType = 'mobile'
          } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            screenType = 'tablet'
          } else if (window.matchMedia('(min-width: 1025px) and (max-width: 1550px)').matches) {
            screenType = 'laptop'
          } else {
            screenType = 'desktop'
          }

          const selectedData = val[screenType]

          // Set background if image URL exists
          if (selectedData && selectedData.imgUrl) {
            div.style.removeProperty('display')
            div.style.backgroundImage = `url('${selectedData.imgUrl}')`
            div.style.cursor = selectedData.url ? 'pointer' : 'default'
          } else {
            div.style.setProperty('display', 'none', 'important')
          }

          // Remove old event by cloning (prevent stacking events)
          const newDiv = div.cloneNode(true)
          div.parentNode.replaceChild(newDiv, div)

          // Add click event if link exists
          if (selectedData && selectedData.url) {
            newDiv.addEventListener('click', () => {
              window.open(selectedData.url, '_blank')
            })
          }
        } else {
          this.isHideBanner = true
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.isHideBanner = JSON.parse(localStorage.getItem('isHideBanner'))
  },

  methods: {
    handleHideBanner() {
      this.isHideBanner = !this.isHideBanner
      localStorage.setItem('isHideBanner', JSON.stringify(this.isHideBanner))
    },

    // goToSupport() {
    //   if (window.fcWidget?.isOpen() !== true) {
    //     window.fcWidget.open()
    //   }
    // },

    // goToDocsBanner() {
    //   if (this.link) {
    //     if (this.link === 'livechat') {
    //       this.goToSupport()
    //     } else {
    //       window.open(this.link)
    //     }
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
.banner-header-container {
  height: 270px;
  width: 100%;

  border-radius: var(--border-radius-2xl);
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-bottom: 1rem;

  .btn-join-partnero {
    width: max-content;
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(0, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    .content-background {
      text-align: center;

      .title-ecomdy-affiliate {
        margin-bottom: 1rem;
        font-size: 32px;
        color: #fff;

        .text-opacity{
          color: rgba(255, 255, 255, 0.70)
        }

        @media (max-width: 992px) {
          font-size: 25px;
        }

        @media (max-width: 768px) {
          font-size: 18px;
        }
      }
    }

    .btn-controller {

      .btn-learn-more {
        padding: 12px 16px;
        border-radius: var(--btn-border-radius-base);
        border: 1px solid #FFF;
        width: 145px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
          line-height: 20px;
          font-size: 20px;
          color: #fff;

          @media (max-width: 768px) {
            font-size: 18px;
          }
        }
      }

      @media (max-width: 575px) {
        flex-direction: column;
        align-items: start;
      }
    }

    @media (max-width: 768px) {
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  @media (max-width: 575px) {
    height: 250px;
  }
}
</style>
